import React, { useEffect, useRef } from 'react';
import { Bar } from 'react-chartjs-2';
import { useIsMobile } from '@/hooks';
import { useTranslation } from 'react-i18next';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';

type Productividades = {
  mes: string;
  mesSpecified: boolean;
  porcentaje: number;
  porcentajeSpecified: boolean;
};

type ThickBarChartWithoutAxesProps = {
  data: Productividades[];
};
/* eslint-disable*/
const valueAboveBarsPlugin = {
  id: 'valueAboveBars',
  afterDatasetsDraw: (chart: any) => {
    const { ctx } = chart;
    chart.data.datasets.forEach((dataset: any, i: any) => {
      const meta = chart.getDatasetMeta(i);
      meta.data.forEach((bar: any, index: any) => {
        const value = dataset.data[index];
        ctx.fillStyle = '#223466';
        ctx.font = 'bold 14px';
        ctx.textAlign = 'center';
        const position = bar.tooltipPosition();
        ctx.fillText(value, position.x, position.y - 10);
      });
    });
  },
};

const ThickBarChartWithoutAxes: React.FC<ThickBarChartWithoutAxesProps> = ({
  data,
}) => {
  const { t, i18n } = useTranslation('dashboardPage');
  const isMobile = useIsMobile();
  const capitalize = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const getDataForThickBarWithoutLegendChart = (dataP: Productividades[]) => {
    const labels = dataP.map((item) => {
      const date = new Date(item.mes);
      const formattedDate = date.toLocaleString(i18n.language, {
        month: 'short',
        year: 'numeric',
      });

      return capitalize(formattedDate);
    });

    return {
      labels,
      datasets: [
        {
          data: dataP.map((item) => item.porcentaje),
          backgroundColor: '#7dd19d',
          borderRadius: 6,
          barThickness: isMobile ? 30 : 90,
        },
      ],
    };
  };

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    valueAboveBarsPlugin
  );
  const chartRef = useRef<ChartJS<'bar'> | null>(null);
  const chartData = getDataForThickBarWithoutLegendChart(data);

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    layout: {
      padding: {
        top: 20, // Añadimos un padding superior para que los valores no se corten
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        display: true,
        align: 'center',
        grid: {
          lineWidth: 0,
        },
      },
      y: {
        display: false,
        lineWidth: 0,
      },
    },
  };

  useEffect(() => {
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
      }
    };
  }, []);

  if (data.length === 0) {
    return (
      <div className="w-full h-full flex align-items-center justify-content-center">
        {t('noInformationAvailable')}
      </div>
    );
  }

  return (
    <div
      style={{
        width: '100%',
        height: isMobile ? '230px' : '390px',
        marginBottom: isMobile ? '0px' : '20px',
      }}
    >
      <Bar
        style={{ paddingBottom: isMobile ? 0 : 35 }}
        data={chartData}
        options={options}
      />
    </div>
  );
};

export default ThickBarChartWithoutAxes;
